module.exports = new __parcel__URL__("sample-check.7ec93ee3.png").toString();